import { render, staticRenderFns } from "./ReportTickets.vue?vue&type=template&id=228fcab6&scoped=true"
import script from "./ReportTickets.vue?vue&type=script&lang=js"
export * from "./ReportTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228fcab6",
  null
  
)

export default component.exports